var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn_white btn-reflection",attrs:{"disabled":!_vm.all_approval},on:{"click":_vm.action}},[_vm._v("\n  申請をシフト表へ反映\n")])}
var staticRenderFns = []

export { render, staticRenderFns }